import React from 'react';
import '../styles/smile-spinner.css'

const SmileSpinner = () => (
    <div className="smile-spinner">
    </div>
);

export default SmileSpinner;